import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/drawing',
    name: 'drawing',
    component: () => import( /* webpackChunkName: "drawing" */ '../views/drawing.vue')
  },
  {
    path: '/alternating',
    name: 'alternating',
    component: () => import( /* webpackChunkName: "alternating" */ '../views/alternating.vue')
  },
  {
    path: '/blogroll',
    name: 'blogroll',
    component: () => import( /* webpackChunkName: "blogroll" */ '../views/blogroll.vue')
  },
  {
    path: '/blogroll-details',
    name: 'blogroll-details',
    component: () => import( /* webpackChunkName: "blogroll-details" */ '../views/blogroll-details.vue')
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import( /* webpackChunkName: "policy" */ '../views/policy.vue')
  },
  {
    path: '/police-details',
    name: 'police-details',
    component: () => import( /* webpackChunkName: "police-details" */ '../views/police-details.vue')
  },
  {
    path: '/result',
    name: 'result',
    component: () => import( /* webpackChunkName: "result" */ '../views/result.vue')
  },
  {
    path: '/understand',
    name: 'understand',
    component: () => import( /* webpackChunkName: "understand" */ '../views/understand.vue')
  },
  {
    path: '/result-details',
    name: 'result-details',
    component: () => import( /* webpackChunkName: "result-details" */ '../views/result-details.vue')
  },
  {
    path: '/alternating-details',
    name: 'alternating-details',
    component: () => import( /* webpackChunkName: "alternating-details" */ '../views/alternating-details.vue')
  },
  {
    path: '/report',
    name: 'report',
    component: () => import( /* webpackChunkName: "report" */ '../views/drawingList/report.vue')
  },
  {
    path: '/examine',
    name: 'examine',
    component: () => import( /* webpackChunkName: "examine" */ '../views/drawingList/examine.vue')
  },
  {
    path: '/collection',
    name: 'collection',
    component: () => import( /* webpackChunkName: "collection" */ '../views/drawingList/collection.vue')
  },
  {
    path: '/reply',
    name: 'reply',
    component: () => import( /* webpackChunkName: "reply" */ '../views/drawingList/reply.vue')
  },
  {
    path: '/reply-details',
    name: 'reply-details',
    component: () => import( /* webpackChunkName: "reply-details" */ '../views/drawingList/reply-details.vue')
  },
  {
    path: '/point',
    name: 'point',
    component: () => import( /* webpackChunkName: "point" */ '../views/drawingList/point.vue')
  },
  {
    path: '/point-details',
    name: 'point-details',
    component: () => import( /* webpackChunkName: "point-details" */ '../views/drawingList/point-details.vue')
  },
]

const router = new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {

    return {

      x: 0,

      y: 100

    }

  }

})

export default router
